export default __webpack_public_path__ + "static/media/thumbnail.fa819c9d.webp";